export default function initRangeSlider() {
    const rangeInput = document.querySelectorAll(".range-input input") as NodeListOf<HTMLFormElement>;
    const priceInput = document.querySelectorAll(".price-slider__input input") as NodeListOf<HTMLFormElement>;
    const range = document.querySelector(".price-slider__slider .progress") as HTMLBaseElement;
    const context = document.querySelector(".js-apply-price-filter") as HTMLBaseElement;
    let priceGap = 10;
    let timer;


    // Text input event listener
    priceInput.forEach((input) => {
        input.addEventListener("input", (e) => {
            let minPrice = parseInt(priceInput[0].value),
                maxPrice = parseInt(priceInput[1].value);

            if (maxPrice - minPrice >= priceGap && maxPrice <= rangeInput[1].max) {

                const target = e.target as HTMLBaseElement

                if (target.className === "input-min") {
                    rangeInput[0].value = minPrice;
                    range.style.left = (minPrice / rangeInput[0].max) * 100 + "%";
                } else {
                    rangeInput[1].value = maxPrice;
                    range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
                }

                updateFilterURL(minPrice, maxPrice, context);
            }
        });
    });


    // range input event listener
    rangeInput.forEach((input) => {
        input.addEventListener("input", (e) => {
            let minVal = parseInt(rangeInput[0].value),
                maxVal = parseInt(rangeInput[1].value);

            if (maxVal - minVal < priceGap) {
                const target = e.target as HTMLBaseElement;
                if (target.className === "range-min") {
                    rangeInput[0].value = maxVal - priceGap;
                } else {
                    rangeInput[1].value = minVal + priceGap;
                }

            } else {
                priceInput[0].value = minVal;
                priceInput[1].value = maxVal;
                range.style.left = (minVal / rangeInput[0].max) * 100 + "%";
                range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
            }

            clearTimeout(timer);
            timer = setTimeout(() => {
                updateFilterURL(minVal, maxVal, context);
            }, 300);
             
        });
    });
}

const updateFilterURL = (min, max, context) => {
    let url = window.location.href;
    let query;    

    if (url.indexOf("price") > -1) {
        url = url.replace(/(price=)[^\&]+/, '$1' + min + ";" + max);
    } else {
        if (url.indexOf("?") > -1) query = "&price=" + min + ";" + max;
        else query = "?price=" + min + ";" + max;        
        url = url + query;
    }

    context.setAttribute('href', url);
}